var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebLavatoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5464",
    "data-name": "Group 5464",
    transform: "translate(-984 -507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M40,0H5A5.015,5.015,0,0,0,0,5V40a5.015,5.015,0,0,0,5,5H40a5.015,5.015,0,0,0,5-5V5a5.015,5.015,0,0,0-5-5Z",
    transform: "translate(984 507)",
    fill: "#1e4b82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5421",
    "data-name": "Group 5421",
    transform: "translate(-50 -444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-right",
    transform: "translate(1040.4 959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M3.239,0,0,3.239,10.642,13.881,0,24.523l3.239,3.239L17.12,13.881Z",
    transform: "translate(0.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M3.239,0,0,3.239,10.642,13.881,0,24.523l3.239,3.239L17.12,13.881Z",
    transform: "translate(13.6)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLavatoryIcon);
export default __webpack_public_path__ + "static/media/Web_Lavatory_Icon.7e9ad963cff053e07010f9e13a9d4363.svg";
export { ForwardRef as ReactComponent };